import {
  FieldDef,
  formatDate,
  formatDateTime,
  formatDollarAmount,
} from "@synota-io/synota-shared-ui";
import { IPayment } from "../../../../api/hooks/usePayments";

export const paymentFields: FieldDef<IPayment>[] = [
  {
    field: "shared_uuid",
    headerName: "ID",
    minWidth: 120,
    displayTags: ["details"],
    type: "number",
  },
  {
    field: "invoice_number",
    headerName: "Invoice Number",
    minWidth: 120,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "payment_number",
    headerName: "Payment ID",
    minWidth: 120,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "energy_date",
    headerName: "Energy Date",
    minWidth: 120,
    type: "number",
    displayTags: ["summary", "table"],
    valueFormatter: (value) => formatDate(value),
  },
  {
    field: "payment_datetime",
    headerName: "Payment Date (UTC)",
    minWidth: 170,
    type: "number",
    valueFormatter: (value) => formatDateTime(value),
  },
  {
    field: "payment_amount",
    headerName: "Payment Amount",
    minWidth: 190,
    type: "number",
    displayTags: ["summary", "table"],
    valueFormatter: (value) => formatDollarAmount(value),
  },
  {
    field: "payment_status",
    headerName: "Payment Status",
    minWidth: 190,
    type: "number",
    displayTags: ["summary", "table"],
  },
];
